/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressV1Dto } from './AddressV1Dto';
import type { ContactPersonToPartnerV1Dto } from './ContactPersonToPartnerV1Dto';
import type { PartnerBankingAccountV1Dto } from './PartnerBankingAccountV1Dto';
export type PartnerV2Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The email address of the partner.
   */
  eMail?: string | null;
  /**
   * The language of correspondence with the partner.
   */
  languageOfCorrespondence?: PartnerV2Dto.languageOfCorrespondence | null;
  /**
   * The name of the partner.
   */
  name: string;
  /**
   * The unique identifier as hexadecimal value of the partner group linked to this partner. As 8-4-4-4-12 format.
   */
  partnerGroupId: string;
  /**
   * The phone number of the partner.
   */
  phone?: string | null;
  /**
   * Addresses associated with the partner
   */
  addresses?: Array<AddressV1Dto> | null;
  /**
   * Contact persons associated with the customer
   */
  contactPersonToPartner?: Array<ContactPersonToPartnerV1Dto> | null;
  /**
   * Banking accounts for the customer
   */
  bankingAccounts?: Array<PartnerBankingAccountV1Dto> | null;
};
export namespace PartnerV2Dto {
  /**
   * The language of correspondence with the partner.
   */
  export enum languageOfCorrespondence {
    GERMAN = 'german',
    ENGLISH = 'english',
  }
}
